import {createRoot} from 'react-dom/client';

import ApplicationLayout from '@js/components/layouts/application';

require('@js/common');

const shopElement = document.getElementById('shops-component');

if (shopElement) {
    const root = createRoot(document.getElementById('shops-component'));
    root.render(
        <ApplicationLayout componentId="shops-component"/>
    );
}
